import { useAccountCompanyId } from 'application/hooks';
import { useUserBillingInfo } from '@entities/billing';
import { useAppSelector } from 'application/providers/StoreProvider';
import { selectIsChangePricePlanAvailable } from 'application/store';

import { OrganizationDiscountStatus } from '@shared/api/graphql/generated';

interface UseRatesTableViewModel {
  isChangePricePlanAvailable: boolean;
  isPrimeDiscountAvailable: boolean;
  primeDiscountValue?: number;
}

const SBER_PRIME_SLUG = 'sber_prime';

const useRatesTableViewModel = (): UseRatesTableViewModel => {
  const isChangePricePlanAvailable = useAppSelector(selectIsChangePricePlanAvailable);

  const companyId = useAccountCompanyId();

  const { watchBillingInfo } = useUserBillingInfo();

  const { discount } = watchBillingInfo(companyId);

  const isPrimeDiscountAvailable =
    discount?.slug === SBER_PRIME_SLUG && discount.status === OrganizationDiscountStatus.InProgress;
  const primeDiscountValue = discount?.value;

  return {
    isChangePricePlanAvailable,
    isPrimeDiscountAvailable,
    primeDiscountValue,
  };
};

export default useRatesTableViewModel;
